import React, { useState } from "react";

const faqs = [
  {
    question: "How do I reset my password?",
    answer: "You can reset your password by clicking on 'Forgot Password' on the login page and following the instructions.",
  },
  {
    question: "How to track my transaction status?",
    answer: "Go to the Transactions page and click on the specific transaction to see its detailed status.",
  },
  {
    question: "What are the fees for international transfers?",
    answer: "Fees vary based on destination country and amount. Please refer to our Fees section or contact support for details.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section className="bg-gray-50 dark:bg-gray-900 p-6 rounded-lg shadow-md max-w-xl mx-auto">
      <h3 className="text-2xl font-semibold mb-6 text-gray-900 dark:text-white">
        Frequently Asked Questions
      </h3>

      <div className="space-y-4">
        {faqs.map(({ question, answer }, idx) => (
          <div
            key={idx}
            className="border border-gray-300 dark:border-gray-700 rounded-md overflow-hidden"
          >
            <button
              onClick={() => toggleIndex(idx)}
              className="w-full text-left px-4 py-3 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-200 flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <span className="font-medium">{question}</span>
              <svg
                className={`w-5 h-5 transform transition-transform ${
                  openIndex === idx ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>
            {openIndex === idx && (
              <div className="px-4 py-3 bg-gray-50 dark:bg-gray-900 text-gray-700 dark:text-gray-400">
                {answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
